var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.showSizeStock
        ? _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("stock-per-size")))]),
              _c(
                "w-card-content",
                { style: { padding: 0 } },
                [
                  _c(
                    "app-custom-table",
                    { attrs: { cellpadding: "0", cellspacing: "0" } },
                    [
                      _c("thead", [
                        _c(
                          "tr",
                          [
                            _c("th", { staticStyle: { width: "30%" } }, [
                              _vm._v(_vm._s(_vm.$ct("size"))),
                            ]),
                            _vm._l(_vm.sizeStockLocations, function (loc) {
                              return _c(
                                "th",
                                { key: loc.id, staticClass: "amount" },
                                [_vm._v(_vm._s(loc.name))]
                              )
                            }),
                            _c("th", { staticClass: "amount" }, [
                              _vm._v(_vm._s(_vm.$ct("total-stock"))),
                            ]),
                          ],
                          2
                        ),
                      ]),
                      _c(
                        "tbody",
                        _vm._l(_vm.sizeStocks, function (s, idx) {
                          return _c(
                            "tr",
                            { key: idx },
                            [
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    s.SizeTableEntry
                                      ? s.SizeTableEntry.Name
                                      : "?"
                                  )
                                ),
                              ]),
                              _vm._l(_vm.sizeStockLocations, function (loc) {
                                return _c(
                                  "td",
                                  { key: loc.id, staticClass: "amount" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(s.getStockAtLocation(loc.id)) +
                                        " "
                                    ),
                                  ]
                                )
                              }),
                              _c("td", { staticClass: "amount" }, [
                                _c("b", [_vm._v(_vm._s(s.getTotalInStock()))]),
                              ]),
                            ],
                            2
                          )
                        }),
                        0
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-card",
        { class: _vm.showSizeStock ? "mt" : "" },
        [
          _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("current-stock-status")))]),
          _c(
            "w-card-content",
            { style: { padding: 0 } },
            [
              _c(
                "app-custom-table",
                { attrs: { cellpadding: "0", cellspacing: "0" } },
                [
                  _c("thead", [
                    _c("tr", [
                      _c("th", { staticStyle: { width: "50%" } }, [
                        _vm._v(" " + _vm._s(_vm.$ct("location")) + " "),
                      ]),
                      _c("th", { staticClass: "amount" }, [
                        _vm._v(" " + _vm._s(_vm.$ct("amount")) + " "),
                      ]),
                      _c("th", [_vm._v(" ")]),
                    ]),
                  ]),
                  _c(
                    "tbody",
                    _vm._l(_vm.actualStock, function (stock, i) {
                      return _c("tr", { key: i }, [
                        _c("td", [_vm._v(_vm._s(stock.text))]),
                        _c("td", { staticClass: "amount" }, [
                          _vm._v(" " + _vm._s(stock.stock) + " "),
                        ]),
                        _c("td"),
                      ])
                    }),
                    0
                  ),
                  _c("tfoot", [
                    _c("tr", [
                      _c(
                        "td",
                        [
                          _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.$ct(
                                    "tooltip.stock-movement-report"
                                  ),
                                  expression:
                                    "$ct('tooltip.stock-movement-report')",
                                },
                              ],
                              attrs: { icon: "", flat: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.openStockReportModal()
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "download" } })],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("td", { staticClass: "amount" }, [
                        _c("b", [
                          _vm._v(
                            _vm._s(_vm.$ct("total-stock")) +
                              ": " +
                              _vm._s(_vm.totalStock)
                          ),
                        ]),
                      ]),
                      _c("td"),
                    ]),
                  ]),
                ]
              ),
              _c(
                "w-modal",
                {
                  model: {
                    value: _vm.reportModal,
                    callback: function ($$v) {
                      _vm.reportModal = $$v
                    },
                    expression: "reportModal",
                  },
                },
                [
                  _c(
                    "w-card",
                    { attrs: { "max-width": "500" } },
                    [
                      _c("w-card-title", [
                        _vm._v(_vm._s(_vm.$ct("stock-transfer-title"))),
                      ]),
                      _c(
                        "w-card-content",
                        [
                          _c(
                            "w-row",
                            [
                              _c(
                                "w-col",
                                { attrs: { xs: "12", md: "6" } },
                                [
                                  _c("w-date-picker", {
                                    attrs: {
                                      label: _vm.$ct("start-date"),
                                      fancy: "",
                                    },
                                    model: {
                                      value: _vm.reportStart,
                                      callback: function ($$v) {
                                        _vm.reportStart = $$v
                                      },
                                      expression: "reportStart",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { xs: "12", md: "6" } },
                                [
                                  _c("w-date-picker", {
                                    attrs: {
                                      label: _vm.$ct("end-date"),
                                      fancy: "",
                                    },
                                    model: {
                                      value: _vm.reportEnd,
                                      callback: function ($$v) {
                                        _vm.reportEnd = $$v
                                      },
                                      expression: "reportEnd",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "w-card-actions",
                        [
                          _c(
                            "w-button",
                            {
                              on: {
                                click: function ($event) {
                                  _vm.reportModal = false
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$ct("common.cancel")) + " "
                              ),
                            ]
                          ),
                          _c("w-spacer"),
                          _c(
                            "w-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.downloadStockMovement()
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$ct("common.confirm")) + " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }